module.exports = __webpack_public_path__ + "static/media/40.53eb838f.jpg";